export enum DonationFrequency {
  Weekly = 0,
  BiWeekly = 1,
  Monthly = 2,
  Quarterly = 3,
  Yearly = 4,
}
